"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _icon = _interopRequireDefault(require("../icon"));

var styles = {
  "icon": "link-icon-_QgXo"
};

var Link = /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
  var children = _ref.children,
      _ref$external = _ref.external,
      external = _ref$external === void 0 ? false : _ref$external,
      _ref$icon = _ref.icon,
      icon = _ref$icon === void 0 ? external : _ref$icon,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, ["children", "external", "icon"]);
  var ownProps = {};

  if (external) {
    ownProps.target = '_blank';
    ownProps.rel = 'noopener noreferrer';
  }

  return /*#__PURE__*/_react["default"].createElement("a", (0, _extends2["default"])({
    ref: ref
  }, ownProps, restProps), children, external && icon && /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    className: styles.icon,
    src: "#open-in-new",
    "aria-hidden": true
  }));
});

Link.propTypes = {
  href: _propTypes["default"].string,

  /**
   * Indicates whether link is external or not.
   *
   * External links contain additional icon and add additional attributes to
   * the link: `target="_blank" rel="noopener noreferrer"`.
   * See more: [Links to cross-origin destinations are
   * unsafe](https://web.dev/external-anchors-use-rel-noopener/).
   */
  external: _propTypes["default"].bool,

  /**
   * Indicates whether the external icon should be shown or not.
   * Applies only when link is external and its default
   * reflects external prop.
   */
  icon: _propTypes["default"].bool
};
Link.defaultProps = {
  external: false,
  icon: false
};
var _default = Link;
exports["default"] = _default;